<template>
  <div id="app">
    <Title :title="$route.meta.title"></Title>
    <!-- <router-link to="/">Main Dashboard</router-link> -->
    <router-view/>
  </div>
</template>

<script>
import Title from './components/Title.vue';

export default {
  name: 'app',
  components: {
    Title,
  },
};
</script>

<style>
  #app {

  }
</style>
